import { Tag } from '../CheckIn/FerryCheckIn/CheckInList/Tag';

export default function GuestTag() {
	return <Tag text="Guest" tagClassName="tag--new" />;
}
